import script from "./StaffForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffForm.vue?vue&type=script&setup=true&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=766b31fa&lang=scss"
import "./StaffForm.vue?vue&type=style&index=1&id=766b31fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766b31fa"]])

export default __exports__